var dsox = dsox || {};
dsox.Accordion = (function () {
    
    var toggleIcon = function ($) {
        $(document).on('click', '.js-toggle-accordion', function(){
            $('.js-toggle-accordion').each(function(){
				var accordionItems = $(this);
				if(accordionItems.attr('aria-expanded') == "false"){
					accordionItems.find('[data-fa-i2svg]').removeClass('fa-minus-circle').addClass('fa-plus-circle');
				}
			});

			var accordionItem = $(this);
			if(accordionItem.attr('aria-expanded') == "true"){
				accordionItem.find('[data-fa-i2svg]').removeClass('fa-plus-circle').addClass('fa-minus-circle');
			} else {
				accordionItem.find('[data-fa-i2svg]').removeClass('fa-minus-circle').addClass('fa-plus-circle');
			}
        })
    }

    return {
        toggleIcon: toggleIcon
    }

}());